import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Client } from '@pixacare/domain';
import { Observable, switchMap } from 'rxjs';
import { selectClient } from 'src/app/shared/store/clients/clients.selectors';
import { selectClientCode } from 'src/app/shared/store/router/router.selectors';

@Injectable()
export class ClientAdminService {
  private readonly store = inject(Store);

  readonly clientCode$: Observable<string> = this.store.select(selectClientCode);
  readonly client$: Observable<Client> = this.clientCode$.pipe(
    switchMap((clientCode) => this.store.select(selectClient(clientCode))),
  );
}
